import { render, staticRenderFns } from "./SizeAndBloodWidget.vue?vue&type=template&id=66de1407&"
import script from "./SizeAndBloodWidget.vue?vue&type=script&lang=js&"
export * from "./SizeAndBloodWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports